import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/certification/certificationData.json";

export default function Certification() {
  useSEO(seoConfig.certification);

  return (
    <section className="licenses antiCorruption development">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Аттестация научных работников
      </h1>

      <Accordion data={data} />
    </section>
  );
}
